import React from 'react'
import { Box, Flex } from '@workwhile/ui'
import { UserPaymentsHeader } from './UserPaymentsHeader'
import { UserPaymentsTable } from './UserPaymentsTable'
import { UserPaymentFilters } from './UserPaymentFilters/UserPaymentFilters'
import { ColumnsFilter } from './ColumnsFilter'

export const UserPaymentsMain = () => {
  return (
    <>
      <UserPaymentsHeader />
      <Box margin={3}>
        <Flex justifyContent="left" alignItems="center" mb={3}>
          <UserPaymentFilters />
        </Flex>
        <Flex justifyContent="right" alignItems="center" mb={3}>
          <ColumnsFilter />
        </Flex>
        <UserPaymentsTable />
      </Box>
    </>
  )
}
